import CurrencyActions from '../../../../actions/CurrencyActions';
import {
    getHeaderNames,
    getCurrencyRatios
} from './CurrencyRatioPageContainer.selectors';
import query from '../../../../helpers/query';
import store from '../../../../stores/redux';

export const actions = {
    getCurrencyRatios(state) {
        const params = {
            ...query.parseToSend(state),
            currency: undefined
        };

        CurrencyActions.getCurrencyRatios(params);
    },

    getCurrenciesList() {
        let list = [];
        const currenciesList = store.getState().currency.list;
        let storeServerStorage = store.getState().serverStorage.store;
        let storeCurrencies = storeServerStorage.dataTable.currencies;

        if (currenciesList.length) {
            currenciesList.map((element) => {
                let isVisible = false;
                if (storeCurrencies && storeCurrencies.length) {
                    let currency = storeCurrencies.find(currencyObj => {
                        return currencyObj.keyTitle === element.title;
                    });
                    isVisible = currency ? currency.visible : isVisible;
                }

                if (!element.supported) {
                    list.push({
                        'keyTitle': element.title,
                        'title': element.title,
                        'visible': isVisible
                    });
                }
            });
        }

        return list;
    },

    onChangeData(state, callback) {
        let currencyRatios = store.getState().currencyRatios.list;
        let currencies = store.getState().currency.list;

        callback({
            headerNames: getHeaderNames(currencyRatios, state.currency),
            currencyRatios: getCurrencyRatios(currencyRatios, currencies, state.currency)
        });
    }
};
